import type * as Types from '../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetYandexHistoryQueryVariables = Types.Exact<{
  timeFrom: Types.Scalars['String']['input'];
  timeTo: Types.Scalars['String']['input'];
  projectUuid: Types.Scalars['String']['input'];
}>;


export type GetYandexHistoryQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly yandexHistory?: ReadonlyArray<{ readonly __typename?: 'FlashpointYandexHistory', readonly accountId?: string | null, readonly accountName?: string | null, readonly campaignId?: string | null, readonly campaignName?: string | null, readonly adGroupId?: string | null, readonly adGroupName?: string | null, readonly adId?: string | null, readonly adName?: string | null, readonly time: string, readonly category: string, readonly categoryDescription: string, readonly type: string, readonly typeDescription: string, readonly valueBefore?: Record<string, any> | null, readonly valueAfter?: Record<string, any> | null } | null> | null } | null };

export type GetCurrentUserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly currentCompany?: { readonly __typename?: 'AccountsCompany', readonly id: string, readonly name: string, readonly uuid: string } | null } | null };


export const GetYandexHistoryDocument = gql`
    query GetYandexHistory($timeFrom: String!, $timeTo: String!, $projectUuid: String!) {
  currentUser {
    yandexHistory(timeFrom: $timeFrom, timeTo: $timeTo, projectUuid: $projectUuid) {
      accountId
      accountName
      campaignId
      campaignName
      adGroupId
      adGroupName
      adId
      adName
      time
      category
      categoryDescription
      type
      typeDescription
      valueBefore
      valueAfter
    }
  }
}
    `;

/**
 * __useGetYandexHistoryQuery__
 *
 * To run a query within a React component, call `useGetYandexHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetYandexHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetYandexHistoryQuery({
 *   variables: {
 *      timeFrom: // value for 'timeFrom'
 *      timeTo: // value for 'timeTo'
 *      projectUuid: // value for 'projectUuid'
 *   },
 * });
 */
export function useGetYandexHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetYandexHistoryQueryPage, GetYandexHistoryQueryVariables> & ({ variables: GetYandexHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetYandexHistoryQueryPage, GetYandexHistoryQueryVariables>(GetYandexHistoryDocument, options);
      }
export function useGetYandexHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetYandexHistoryQueryPage, GetYandexHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetYandexHistoryQueryPage, GetYandexHistoryQueryVariables>(GetYandexHistoryDocument, options);
        }
export function useGetYandexHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetYandexHistoryQueryPage, GetYandexHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetYandexHistoryQueryPage, GetYandexHistoryQueryVariables>(GetYandexHistoryDocument, options);
        }
export type GetYandexHistoryQueryHookResult = ReturnType<typeof useGetYandexHistoryQuery>;
export type GetYandexHistoryLazyQueryHookResult = ReturnType<typeof useGetYandexHistoryLazyQuery>;
export type GetYandexHistorySuspenseQueryHookResult = ReturnType<typeof useGetYandexHistorySuspenseQuery>;
export type GetYandexHistoryQueryResult = Apollo.QueryResult<GetYandexHistoryQueryPage, GetYandexHistoryQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser {
  currentUser {
    currentCompany {
      id
      name
      uuid
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;